// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"195":"DanceSchoolPromotion","480":"BirthCenters","527":"RequestForShop","535":"PricingDetails","561":"Dashboard","967":"ShopRequestTimeline"}[chunkId] + "." + {"195":"632de031","480":"df050801","527":"b8405ac4","535":"9442e9f5","561":"ef8ac6fc","967":"8efed4ad"}[chunkId] + ".css";
};